import { render } from "./NobrandTips.vue?vue&type=template&id=7fa5c5db&scoped=true"
import script from "./NobrandTips.vue?vue&type=script&lang=js"
export * from "./NobrandTips.vue?vue&type=script&lang=js"

import "./NobrandTips.vue?vue&type=style&index=0&id=7fa5c5db&scoped=true&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa5c5db"]])

export default __exports__